import React, { useRef, useEffect, useState } from 'react';
import { Wrapper } from './styled';
import { UbicationSite, Logo, BreadCrumb, NavBar } from '@app/src/common/header';
import { isClientEnv } from '@app/src/utils/validations';

interface Props {
  itemActive?: string;
  navBar?: boolean;
  ubicationSite?: boolean;
  positionOf?: Array<number>;
}

const isClient = isClientEnv();
const TABLET_LANDSCAPE: number = 768;

export const Header: React.FC<Props> = ({
  itemActive,
  ubicationSite,
  navBar,
  positionOf
}) => {
  const headerRef = useRef(null);
  const [ headerHeight, setHeaderHeight ] = useState(0);

  useEffect(() => {
    headerRef && setHeaderHeight(headerRef.current.offsetHeight);
  });

  const milestones = {};
  const [ isShow, setIsShow ] = useState(false);

  useEffect(() => {
    if(isClient) {
      window.addEventListener('load', handleHeaderFixed)
      window.addEventListener('scroll', handleHeaderFixed);
      setElementsByScrolling();
      return () => {
        window.removeEventListener('scroll', handleHeaderFixed);
        window.removeEventListener('load', handleHeaderFixed);
        document.body.style.paddingTop = '0px';
      };
    }
  });

  const setElementsByScrolling = (): void => {
    const arrMilestones = document.querySelectorAll('[data-scroll]');
    for (let i=0; i < arrMilestones.length; i++) {
      const dataScroll = arrMilestones[i].getAttribute('data-scroll');
      milestones[dataScroll] = arrMilestones[i];
    }
  };

  const handleHeaderFixed = () => {
    const HEADER_HEIGHT: number = 88;
    const isTabletDevice: boolean = window.innerWidth >= TABLET_LANDSCAPE;
    const isHeader: boolean = window.pageYOffset > HEADER_HEIGHT;
    const isNotHeader: boolean = window.pageYOffset <= HEADER_HEIGHT;
    const isAnotherSection: boolean = window.pageYOffset >= getOffsetTop('inmueble');

    if (isTabletDevice) {
      if(isNotHeader) {
        setIsShow(false);
        document.body.style.paddingTop = '0px';
      }
      if (isAnotherSection || isHeader) {
        setIsShow(true);
        document.body.style.paddingTop = `${headerHeight}px`;
      }
    }
  };

  const getOffsetTop = (section:string): number => {
    return milestones[section]['offsetTop'];
  };

  return(
    <Wrapper
      ref={headerRef}
      isShow={isShow}>
      <Logo />
      { ubicationSite && <UbicationSite itemActive={itemActive} />}
      { navBar &&
          <NavBar itemInicio />
      }
      { positionOf && <BreadCrumb positionOf={positionOf} />}
    </Wrapper>
  );
};

Header.displayName = 'Header';
